import { trackEvent } from "./mixpanel";
import { CoachingTourEvents } from "./mixpanel.types";

interface TourEventBase {
  tourId: string;
  version: number;
  stepId: string;
  stepIndex: number;
  stepCount: number;
}

/** Structural mirror of ui-common's `PunchupTourEvent`; ui-common cannot depend on analytics. */
export type TourAnalyticsEvent =
  | (TourEventBase & { type: "step_viewed" })
  | (TourEventBase & {
      type: "cta_clicked";
      actionKind: string;
      target?: string;
    })
  | (TourEventBase & { type: "dismissed"; via: string })
  | (TourEventBase & { type: "completed"; via: string });

const EVENT_NAME: Record<TourAnalyticsEvent["type"], CoachingTourEvents> = {
  step_viewed: CoachingTourEvents.STEP_VIEWED,
  cta_clicked: CoachingTourEvents.CTA_CLICKED,
  dismissed: CoachingTourEvents.DISMISSED,
  completed: CoachingTourEvents.COMPLETED,
};

/** Reports one tour event; `extra` (e.g. `comedianId`) is spread into the properties. */
export function trackTourEvent(
  event: TourAnalyticsEvent,
  extra: Record<string, unknown> = {}
): void {
  const base = {
    tour_id: event.tourId,
    tour_version: event.version,
    step_id: event.stepId,
    step_index: event.stepIndex,
    step_count: event.stepCount,
  };
  const detail =
    event.type === "cta_clicked"
      ? { action_kind: event.actionKind, action_target: event.target }
      : event.type === "step_viewed"
        ? {}
        : { via: event.via };
  trackEvent(EVENT_NAME[event.type], { ...base, ...detail, ...extra });
}
